<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    value-key="name"
                    placeholder="请选择仓库"/>
</template>

<script>
  /**
   * @Description: 仓库推荐搜索组件
   * @Author: 菩萨蛮
   * @Date: 2020/9/27 11:13 上午
   * @Version v1.0.0
   *
   * 公司的业务千篇一律，复杂的代码好几百行。
   */
  import SearchObj from 'Components/common/search/SearchObj';
  import AutoComplete from '../../../mixins/common/AutoComplete';

  export default {
    name: 'WarehouseAutoComplete',
    mixins: [AutoComplete],
    props: {
      warehouseType: {
        type: null,
        default: 1
      }
    },
    data() {
      return {
        url: '/warehouse/warehouses/available?name=',
        itemName: 'name'
      };
    },
    methods: {
      async supplierSearch(qs, cb) {
        if (qs && qs !== '') {
          const { data } = await
            this.qGet(`${this.url}${qs}&pageSize=5&pageNum=0`);
          cb(data && data.length > 0 ? data : []);
        } else {
          cb([]);
        }
      },
      async selectItem(item) {
            if (item !== null) {
                this.$emit('update:value', item[this.itemName]);
                this.$emit('setValue', {
                    ...item,
                    index: this.index
                });
                this.$emit('setTags', this.getWarehousesSearchValue(item));
            }
        },
      getWarehousesSearchValue(item) {
            return new SearchObj(
                'warehouseId', '发货仓库', item.id, 'warehouse', item.name
            ).tags;
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>
